import { combineReducers } from 'redux'
import theme from './theme/themeSlice'
import auth from './auth'
import base from './base'
import publisherJson from './theme/publisherJsonSlice'

const rootReducer = (asyncReducers) => (state, action) => {
    const combinedReducer = combineReducers({
        theme,
        auth,
        base,
        publisherJson,
        ...asyncReducers,
    })
    return combinedReducer(state, action)
}
  
export default rootReducer
